
var onlinePlayer = function(el){
	var btn = el.querySelector('[data-onlinePlayer-cover]'),
		iframe = el.querySelector('[data-onlinePlayer-iframe]'),
		select = el.querySelector('[data-onlinePlayer-change]'),
		frame = document.querySelector('[data-modules="Trailer"]'),
        age = el.querySelector('[data-onlinePlayer-age]'),
        watchBtns = frame ? frame.querySelector('[data-onlinePlayer-buttons]') : null,
		param = JSON.parse(el.getAttribute('data-param')),
        sendStat = function(){
			try{
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_action': 'online',
                    'event_label': param.source
                });
			} catch (e){console.log('gtag onlinePlayer error', e)}

			try{
                yaCounter28763351.reachGoal('online_activate');
			} catch(e){console.log('ym onlinePlayer error', e)}
		};

	//
	btn.onclick = () => {
		el.classList.add('js-open');
        iframe && iframe.setAttribute('src', param.src);
		sendStat();
		try {this.onActive()} catch (e){}
		
		if(param.series) {
            if(watchBtns) watchBtns.style.opacity = 0;

            age && age.classList.add('as-none');
		}
	}

	if(select){
		select.onchange = function(){
			var selected = this.options[this.selectedIndex],
				url = selected.getAttribute('data-onlinePlayer-field');

			if(url) iframe.setAttribute('src', url);
		}
	}

	return this;
}

export {onlinePlayer}

















